import Vue from 'vue'
import Router from 'vue-router'
import DemoList from '@/pages/demo/List'
import DemoDetail from '@/pages/demo/Detail'
import wx from '@/wx'

Vue.use(Router)
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'DemoList',
      component: DemoList
    }, {
      path: '/demo/detail',
      name: 'DemoDetail',
      component: DemoDetail
    }]
})
// 路由钩子 路由改变跳转页面之前会触发
router.beforeEach((to, from, next) => {
  wx.init().then(data => {
    localStorage.user_id = data.user_id
    localStorage.openid = data.openid
  }).catch(() => {
  }).finally(() => {
    next()
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js